import * as ActionTypes from './types.action';

export const setOrderSource = orderSource => ({
  type: ActionTypes.SET_ORDER_SOURCE,
  orderSource
});



// WEBPACK FOOTER //
// ./actions/orderSource.action.js